import React from "react";
import _ from "lodash";

/**
 * props:
 * - images: [{id, src, title, date}]
 * - activeId
 * - onSelect(id)
 */
const ThumbnailList = ({
  images = [],
  mode,
  activeId,
  origid,
  onSelect = () => {},
}) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const thumbpath = ["sdeck", "recce"].includes(mode) ? "recce" : "photo";

  const clickPath = (img) => {
    if (["sdeck", "recce"].includes(mode)) {
      return `${process.env.PUBLIC_URL}/photoshoot-recce/${img.photoshoot_id}/${mode}/${img.fname}`;
    } else {
      return `${process.env.PUBLIC_URL}/photographer-view-feedback/${img.photoshoot_id}/${img.orig_photo_id ? img.orig_photo_id : origid}/${img.fname}`;
    }
  };

  function reorderPhotos(data) {
    const grouped = _.groupBy(data, "orig_photo_id");
    const seen = new Set();

    return _.flatMap(data, (item) => {
      if (seen.has(item.id)) return [];

      const children = grouped[item.id] || [];
      children.forEach((child) => seen.add(child.id));

      return [item, ...children];
    });
  }

  const getFileName = (path) =>
    path
      .split(/[/\\]/)
      .pop()
      .replace(/\.[^/.]+$/, "");

  return (
    <div className="thumb-list" aria-label="Image thumbnails">
      {reorderPhotos(images).map((img) => (
        <div
          key={img.id}
          role="button"
          tabIndex={0}
          data-id={img.id}
          /* onClick={() => onSelect(img.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(img.id);
            }
          }} */
          className={`thumb-item ${activeId === img.id ? "bg-blue-200" : "bg-gray-100"}`}
        >
          <a href={clickPath(img)}>
            <img
              className="thumb-img"
              src={`${process.env.REACT_APP_API_URL}/photoshoot/${thumbpath}/thumb/${img.fname}`}
              alt={img.title}
            />
            <div className="thumb-meta">
              {/*<div className="thumb-date">{formatDate(img.created_at)}</div>*/}
              <div className="thumb-date">{getFileName(img.filename)}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default ThumbnailList;
